import React from 'react'
import Advertise_1 from '../../../assets/images/home_page_6/advertise/01.png'

const Advertise = () => {
    return (
        <>
            <section id="advertise-six" className="advertise-six-main-block">
                <div className="container">
                    <div className="advertise-six-block">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6">
                                <div className="home-six-banner-dtl">
                                    <h6 className="home-six-sub-title text-white">
                                        Exclusive Offer{" "}
                                        <span className="badge text-bg-primary">-20%Off</span>
                                    </h6>
                                    <h1 className="home-six-title text-white">
                                        Empower Your Digital Success
                                    </h1>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6">
                                <div className="advertise-six-img-block">
                                    <img
                                        src={Advertise_1}
                                        className="img-fluid"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Advertise
